module.exports = __webpack_public_path__ + "img/LCN-Logo-Gelb-Schwarz-WEB.d1880e0d.png";